import React, { Component } from 'react';
import Loading from '../Loading';

class Announcement extends Component {
    constructor(props) {
        super();
        this.buttonName = props.buttonName ?? 'Got It';
        this.onClose = this.onClose.bind(this);
        this.state = {
            isOpen: true,
        };
    }

    onClose() {
        this.setState({ isOpen: false });
    }

    render() {
        const buttonName = this.props.buttonName ?? 'Got It';
        const onClick = this.props.onClick ?? this.onClose;
        return (
            this.state.isOpen && (
                <>
                    <div
                        className={`page-announcement ${this.props.announcement_bar_styles ?? ''}`}
                    >
                        <div className="page-announcement-header">
                            <div className="d-flex gap-10">
                                <img src="/static/img/megaphone.svg" alt="omg" />
                                Announcement
                            </div>
                            <button onClick={this.onClose}>
                                <i className="icon-close" />
                            </button>
                        </div>
                        <div className="page-announcement-body">{this.props.message}</div>
                        <div className="page-announcement-footer">
                            {!this.props.isLink ? (
                                <a
                                    className={`button button-filled button-primary ${
                                        this.props.buttonStyles ?? ''
                                    }`}
                                    href={this.props.href}
                                >
                                    {buttonName}
                                </a>
                            ) : (
                                <div>
                                    <button
                                        className={`button button-filled button-primary ${
                                            this.props.buttonStyles ?? ''
                                        }`}
                                        onClick={onClick}
                                        disabled={this.props.loading}
                                    >
                                        {buttonName}
                                    </button>
                                    <div className="d-flex justify-content-center pt-2">
                                        {this.props.loading && <Loading onlyPreloader />}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )
        );
    }
}
export default Announcement;
